import { Box, CircularProgress, Stack, Typography } from "@mui/joy";
import { Outlet } from "react-router";
import { CssVarsProvider } from "@mui/joy/styles";

import { usePartner } from "../../PartnerContext";
import { theme } from "../../App";


export default function PartnerLayout() {
    const { authStatus } = usePartner();

    if (authStatus === 'idle' || authStatus === 'verifying') {
        return (
            <CssVarsProvider theme={theme}>
                <Box sx={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    height: '100vh', flexDirection: 'column', gap: 2,
                }}>
                    <CircularProgress />
                    <Typography level="body-sm" color="neutral">Проверка партнёрского доступа…</Typography>
                </Box>
            </CssVarsProvider>
        );
    }

    // Если 'unauthed' — PartnerProvider сам редиректнет на /partner/login.
    // Но на всякий случай покажем заглушку.
    if (authStatus === 'unauthed') {
        return (
            <CssVarsProvider theme={theme}>
                <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
                    <Typography level="body-md" color="neutral">Перенаправление…</Typography>
                </Stack>
            </CssVarsProvider>
        );
    }

    return (
        <CssVarsProvider theme={theme}>
            <Outlet />
        </CssVarsProvider>
    );
}